<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid }">
    <form class="form" @submit.prevent="handleSubmit(changePwdAuthed)">
      <ValidationProvider
        hidden
        data-vv-as="email"
        rules="required|min:2|max:50"
        v-slot="{ errors }"
        class="form__element"
      >
        <b-field
          :message="errors[0]"
          class="is-custom-field"
          name="newpassword"
          :label="$t('manageAccount.changepwdform.newpassword.label')"
        >
          <b-input
            type="email"
            class="is-custom-input"
            autocomplete="new-password"
            :placeholder="
              $t('manageAccount.changepwdform.newpassword.placeholder')
            "
            :value="$store.getters['public-auth/authedUser'].email"
            disabled
          />
        </b-field>
      </ValidationProvider>
      <ValidationProvider
        data-vv-as="newpassword"
        rules="required|min:8|max:24|password"
        v-slot="{ errors }"
        class="form__element"
      >
        <b-field
          :message="errors[0]"
          class="is-custom-field"
          name="newpassword"
          :label="$t('manageAccount.changepwdform.newpassword.label')"
        >
          <b-input
            :disabled="isLoadingData"
            type="password"
            class="is-custom-input"
            autocomplete="new-password"
            :placeholder="
              $t('manageAccount.changepwdform.newpassword.placeholder')
            "
            v-model="userinput.newpassword"
          />
        </b-field>
      </ValidationProvider>
      <ValidationProvider
        data-vv-as="newpasswordConfirm"
        :rules="`required|min:8|max:24|confirmed:${userinput.newpassword}|password`"
        v-slot="{ errors }"
        class="form__element"
      >
        <b-field
          name="newpasswordConfirm"
          :message="errors[0]"
          class="is-custom-field"
          :label="$t('manageAccount.changepwdform.newpasswordConfirm.label')"
        >
          <b-input
            autocomplete="new-password"
            :disabled="isLoadingData"
            type="password"
            class="is-custom-input"
            :placeholder="
              $t('manageAccount.changepwdform.newpasswordConfirm.placeholder')
            "
            v-model="userinput.newpasswordConfirm"
          />
        </b-field>
      </ValidationProvider>
      <!-- <div v-if="isErrored" class="has-text-danger mb-5">
                            {{ $t("manage.form.accountnotfound") }}
                        </div> -->
      <div class="field is-grouped">
        <div class="control">
          <button
            :disabled="invalid || isLoadingData"
            class="is-uppercase is-size-6 primary-btn"
            type="submit"
          >
            <span> {{ $t("manageAccount.changepwdform.submit") }}</span>
            <b-icon icon="fas fa-sync-alt" class="ml-1" />
          </button>
          <!-- <button
                                    class="button is-link"
                                    @click="authLogout()"
                                >
                                    Logout
                                </button> -->
        </div>
        <!-- <div class="control">
                                <button class="button is-link is-light">
                                    Cancel
                                </button>
                            </div> -->
      </div>
    </form>
  </ValidationObserver>
</template>
<style lang="scss" scoped>
.spinner-loader {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  // z-index: 10;
  // pointer-events: none;
}
.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--bg-secondary);
  z-index: 1000000000;
  display: flex;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
}
.discover-btn {
  align-self: flex-end;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-sm);
  background: var(--color-primary-alt);
  color: white !important;
}
.form {
  margin: 1rem 0;
  width: 100% !important;
}
.card-content {
  padding: 0;
}
.is-custom-input {
  background: var(--bg);
}

.content {
  margin: 1.5rem 1.5rem 1rem 1.5rem;
  padding: 0;
}
.rel {
  background: var(--bg-secondary);

  position: relative;
  height: 100%;
  width: 100%;
}

.full-carousel {
  overflow: hidden;
  // border-radius: 1rem;
  max-height: 450px;
  margin: 0;
  width: 100%;
  height: 100%;
}
.bg-image {
  border-radius: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;

  // max-height: 450px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  // border: 1px solid red;
  img {
    filter: blur(5px) brightness(0.7);
    transform: scale(1.1);
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }
}

.text-overlay {
  // pointer-events: none;
  position: relative;
  padding: 1rem;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  // background: rgba(var(--bg-rgba), 0.45);
  z-index: 100;
}
.card-collapse {
  .card-collapse-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 1rem;
    margin-bottom: 0;
  }
  width: 100%;
  background: var(--bg);
}
.wrapper-box {
  // border: 1px solid var(--color-danger);
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.submit-btn {
  background: rgba(var(--bg-rgba), 0.3) !important;
  width: 100%;
  min-width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 2rem 0 1.5rem;
  margin: 1rem 0 0 0 !important;
  align-items: center;
  .icon {
    font-size: 2rem !important;
  }
}
.error_field {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 500 !important;
  color: var(--color-danger);
  /* margin-bottom: 0.35rem; */
}
.info-box {
  padding: 1.5rem 1rem 0 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.result-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  background: var(--bg);
  // border-radius: 1rem;
  &.is-errored {
    background: rgba(var(--color-danger-rgba), 0.35) 0%;
  }
}
.result_field {
  font-size: 1.25rem;
  font-weight: 500 !important;
  color: var(--color-primary-alt);
  text-transform: capitalize;
  // color: var(--color-success);
  /* margin-bottom: 0.35rem; */
}

.query_field {
  font-size: 1.25rem;
  font-weight: 500 !important;
  color: var(--color-primary-alt);
  // color: var(--color-success);
  /* margin-bottom: 0.35rem; */
}
.success_field {
  font-size: 1.25rem;
  font-weight: 500 !important;
  // color: var(--color-primary);
  color: var(--color-success);
  /* margin-bottom: 0.35rem; */
}
.result > .result_field {
  text-align: center;
  font-weight: 300;
}
.result {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 1.25rem;
}
</style>
<script>
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { email, max, min, oneOf, required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Campo richiesto",
});

extend("min", {
  ...min,
  message: "Minimo caratteri: {length}",
});
extend("password", {
  validate: (value) => {
    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,24})"
    );

    return strongRegex.test(value);
  },
  message:
    "La password deve contenere 8-24 caratteri, di cui una lettera maiuscola, e un numero",
});
// must match
extend("confirmed", {
  params: ["target"],
  validate(value, { target }) {
    // console.log(initial);
    return value === target;
  },
  message: "Le password non coincidono",
});

extend("max", {
  ...max,
  message: "Massimo caratteri: {length}",
});

extend("email", {
  ...email,
  message: "Indirizzo e-mail non valido.",
});

extend("oneOf", {
  ...oneOf,
  message: "Paese non valido",
});

import * as Cookies from "js-cookie";
import pwdChangeBody from "~/assets/mailtrap-template/pwdUpdatedTemplate.js";
import { apiBaseName, gql } from "~/utils/gql";

const UPDATE_PW_AUTHED = /* GraphQL */ `
  mutation updatePwAuthed($password: String!) {
    updateAuthenticatedPublicUtente(data: { password: $password }) {
      id
    }
  }
`;
export default {
  data() {
    return {
      isLoadingData: false,
      size: 0,
      open: false,
      password: "",
      email: "",
      isErrored: false,
      userinput: {
        email: "",
        // password: "",
        newpassword: "",
        newpasswordConfirm: "",
      },
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  // mounted() {
  //     this.$nextTick(function () {
  //         this.onResize();
  //     });

  //     window.addEventListener("resize", this.onResize);
  // },
  // beforeDestroy() {
  //     window.removeEventListener("resize", this.onResize);
  // },
  methods: {
    async changePwdAuthed() {
      this.isLoadingData = true;
      const { data } = await gql(UPDATE_PW_AUTHED, {
        password: this.userinput.newpassword,
      });

      if (data) {
        // console.log("DATA", data);
        // log out the user
        const timestamp = new Date().toLocaleString("it-IT", {
          timeZone: "Europe/Rome",
        });
        const user = {
          email: this.$store.getters["public-auth/authedUser"].email,
          firstName: this.$store.getters["public-auth/authedUser"].firstName,
          lastName: this.$store.getters["public-auth/authedUser"].lastName,
        };
        await this.$axios
          .$post(`${apiBaseName}/api/notify`, {
            headers: {
              "Content-Type": "application/json",
            },
            mailHeaders: {
              "X-MT-Category": "password-update-success",
            },
            to: `${user.firstName} ${user.lastName} <${user.email}>`,
            subject: "Password aggiornata con successo",
            text: `
                        [TEMPIO DEL FUTURO *PERDUTO]
                        https://www.tempiodelfuturo.art/

                        Aggiornamento password

                        ${timestamp}

                        Ciao ${user.firstName},

                        la tua password è stata aggiornata con successo. Puoi effettuare il login con le
                        nuove credenziali.

                        Se non hai richiesto questa modifica, ti preghiamo di

                        [contattarci]
                        mailto:hello@tempiodelfuturo.art?subject=Password%20cambiata%20senza%20richiesta

                        .

                        TDF*P ${new Date().getFullYear()}

                        Questa è una e-mail automatizzata. Non rispondere a questo messaggio.

                        Facebook

                        Instagram

                        [PRIVACY]
                        https://www.tempiodelfuturo.art/privacy`,

            html: pwdChangeBody(user.firstName, timestamp),
          })
          .then(async (res) => {
            return {
              data: res,
              errors: null,
            };
          })
          .catch((err) => {
            console.log(err);

            return {
              data: null,
              errors: [
                {
                  message: "E999",
                },
              ],
            };
          });
        this.authLogout();
        this.isLoadingData = false;
      } else {
        this.isLoadingData = false;
        this.$emit("error", data);
      }
    },
    async authLogout() {
      try {
        console.log("browser base url: " + process.env.BROWSER_BASE_URL);
        const isDev = process.env.NODE_ENV !== "production";

        await this.$store.dispatch("public-auth/logout");
        await this.$store.dispatch("public-auth/refresh");
        // console.log("logout: " + logout);
        if (
          this.$cookies &&
          this.$cookies.get("authrefToken") &&
          this.$cookies.get("authrefToken").length > 0
        ) {
          Cookies.remove("authrefToken", {
            path: "/",
            domain: isDev ? "localhost" : process.env.BROWSER_BASE_URL,
          });
        }
        this.$store.commit(
          "setSubmission",
          true
          // { root: true }
        );
        // refresh the page

        this.$router.push(this.localePath("/u/recover/success"));
        this.$store.dispatch("setLoggedIn", false);

        // this.$router.go();
      } catch (e) {
        console.error(e);
      } finally {
      }
    },
    setup(props, { emit }) {
      const form = props.submission;

      const submitForm = () => {
        emit("submit", {
          form,
          onComplete: () => {},
          // TODO: Handle Error
          onError: () => {},
        });
      };

      return {
        form,
        submitForm,
      };
    },
  },
};
</script>
